import { ProductCategoryNavbar } from "../components/export"
import ProductList_Compo from '../features/ProductList/ProductList_Compo'

export default function Home() {
  return (
    <>
      <ProductCategoryNavbar />
      <ProductList_Compo />
    </>
  )
}